module.exports = __webpack_public_path__ + "img/category_main_269.c30ba292.jpg";